import { AnchorHTMLAttributes, PropsWithChildren } from 'react'
import { isInSite } from '../../utils'

export function ExternalLink({ children, href, ...rest }: PropsWithChildren<Partial<AnchorHTMLAttributes<never>>>) {
  return (
    <a rel={isInSite(href) ? undefined : 'nofollow'} target="_blank" href={href} {...rest}>
      {children}
    </a>
  )
}
